
export const FilterType = {
  SearchText: 'SearchText',
  AssetType: 'AssetType',
  ImageSize: 'ImageSize',
  VideoDuration: 'VideoDuration',
  DateAdded: 'DateAdded',
  ImportSource: 'ImportSource',
  AssetSource: 'AssetSource',
  SearchLocation: 'SearchLocation',
  TopRatedPerformance: 'TopRatedPerformance',
};

const SearchTextFilter = {
  type: FilterType.SearchText,
  title: _TL_('Search by asset name or ID'),
};

const AssetTypeFilter = {
  type: FilterType.AssetType,
  title: _TL_('Asset type'),
};

const DateAddedFilter = {
  type: FilterType.DateAdded,
  title: _TL_('Date added'),
};

const ImageSizeFilter = {
  type: FilterType.ImageSize,
  title: _TL_('Image size'),
};

const ImportSourceFilter = {
  type: FilterType.ImportSource,
  title: _TL_('Import source'),
};

const AssetSourceFilter = {
  type: FilterType.AssetSource,
  title: _TL_('Source'),
};

const SearchLocationFilter = {
  type: FilterType.SearchLocation,
  title: _TL_('Location'),
};

const VideoDurationFilter = {
  type: FilterType.VideoDuration,
  title: _TL_('Video duration'),
};

const TopRatedPerformanceFilter = {
  type: FilterType.TopRatedPerformance,
  title: _TL_('Top-rated'),
};

export const AllSupportedFilters = {
  [FilterType.SearchText]: SearchTextFilter,
  [FilterType.AssetType]: AssetTypeFilter,
  [FilterType.DateAdded]: DateAddedFilter,
  [FilterType.ImageSize]: ImageSizeFilter,
  [FilterType.ImportSource]: ImportSourceFilter,
  [FilterType.AssetSource]: AssetSourceFilter,
  [FilterType.SearchLocation]: SearchLocationFilter,
  [FilterType.VideoDuration]: VideoDurationFilter,
  [FilterType.TopRatedPerformance]: TopRatedPerformanceFilter,
};
